import ExtendedBadge from "@/components/ExtendedBadge";
import Table from "@/components/Table";
import { statusBadgeVariant } from "@/utils/application-status";
import { Eye } from "lucide-react";
import {  useNavigate } from "react-router-dom";


export default function LicencesApplicationsItem({ ...props }: any) {
    const navigate = useNavigate();

    const handleView = (id: number) => navigate(`/licences/${id}`, {
        state: {
            id,
            licences: props?.content
        }
    })
    return (
        <Table.Row key={props?.id}>
            <Table.Cell>{props?.content?.id}</Table.Cell>
            <Table.Cell>{props?.content?.projectName}</Table.Cell>
            <Table.Cell>{props?.content?.physicalLocation}</Table.Cell>
            <Table.Cell>
                <ExtendedBadge
                    label={props?.content?.applicationStatus}
                    variant={statusBadgeVariant(props?.content?.applicationStatus)} />
            </Table.Cell>
            <Table.Cell>
                <div className="flex items-center space-x-2">
                    <div className="rounded-lg h-8 w-8 flex items-center justify-center border border-[#EDE8E4] cursor-pointer">
                        <Eye size={20} onClick={() => handleView(props?.content?.id)}/>
                    </div>
                    {/*<div>*/}
                    {/*    <MoreVertical className="text-[#6B5C4F] cursor-pointer" size={21} />*/}
                    {/*</div>*/}
                </div>
            </Table.Cell>
        </Table.Row>
    )
}